import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "./Auth";

function Balance() {
  const { user } = useContext(AuthContext);
  const [email, setEmail] = useState(user ? user.email : "");
  const [balance, setBalance] = useState(null);
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    balance: 0,
  });

  useEffect(() => {
    const fetchBalance = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND}/account/balance?email=${email}`
        );
        if (response.ok) {
          const data = await response.json();
          setBalance(data.balance);
        } else {
          console.error(
            "Failed to fetch balance. Server responded with:",
            response.status
          );
        }
      } catch (error) {
        console.error("Error fetching balance:", error);
      }
    };

    fetchBalance();
  }, [email]);

  return (
    <div>
      <h2>User Information</h2>
      <p>Email: {email}</p>
      <p>Balance: ${balance?.toFixed(2)}</p>
    </div>
  );
}

export default Balance;
